// src/components/BottomNav.js
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ReservationChoiceModal from "./modals/ReservationChoiceModal";
import InquiryModal from "./modals/InquiryModal";

/* ─── 인라인 SVG 아이콘들 ─────────────────────── */
const I = {
  home: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 11.5L12 4l9 7.5" />
      <path d="M5 10v9a1 1 0 0 0 1 1h4v-6h4v6h4a1 1 0 0 0 1-1v-9" />
    </svg>
  ),
  reservation: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3.5" y="5" width="17" height="16" rx="2.5" />
      <path d="M3.5 10h17" />
      <path d="M8 3.5v3" />
      <path d="M16 3.5v3" />
      <path d="M8.5 14.5l2 2 4.5-4.5" />
    </svg>
  ),
  shop: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 8h16l-1.4 11a2 2 0 0 1-2 1.7H7.4a2 2 0 0 1-2-1.7L4 8z" />
      <path d="M9 8V6a3 3 0 0 1 6 0v2" />
    </svg>
  ),
  game: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6.5 8h11a4 4 0 0 1 4 4v0a4 4 0 0 1-4 4h-1l-2.2-2.2a1.5 1.5 0 0 0-1.06-.44H10.76a1.5 1.5 0 0 0-1.06.44L7.5 16h-1a4 4 0 0 1-4-4v0a4 4 0 0 1 4-4z" />
      <path d="M9 12h2" />
      <path d="M10 11v2" />
      <circle cx="15" cy="11" r="0.6" fill="currentColor" />
      <circle cx="17" cy="13" r="0.6" fill="currentColor" />
    </svg>
  ),
  inquiry: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 12c0 4.4-4 8-9 8-1.2 0-2.4-.2-3.5-.6L4 21l1.4-3.7C4.5 16 4 14.5 4 12c0-4.4 4-8 9-8s8 3.6 8 8z" />
      <circle cx="12" cy="12" r="0.7" fill="currentColor" />
      <circle cx="9" cy="12" r="0.7" fill="currentColor" />
      <circle cx="15" cy="12" r="0.7" fill="currentColor" />
    </svg>
  ),
};

function NavBtn({ icon, label, onClick, active }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={[
        "flex-1 h-full flex flex-col items-center justify-center gap-0.5",
        "transition-colors",
        active ? "text-amber-600" : "text-stone-600 hover:text-stone-900",
      ].join(" ")}
      aria-label={label}
    >
      <span className="size-6">{icon}</span>
      <span className="text-[10px] font-bold tracking-wide">{label}</span>
    </button>
  );
}

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const [resOpen, setResOpen] = useState(false);
  const [inqOpen, setInqOpen] = useState(false);

  const path = location.pathname;
  const isHome = path === "/";
  const isShop = path.startsWith("/mall") || path.startsWith("/shop");
  const isGame = path.startsWith("/game");

  return (
    <>
      <nav
        className="
          fixed bottom-0 inset-x-0 z-[9990]
          h-[var(--bottom-nav-h)]
          bg-white/95 backdrop-blur-md
          border-t border-stone-200
          shadow-[0_-4px_20px_rgba(0,0,0,0.08)]
          pb-[env(safe-area-inset-bottom)]
        "
        aria-label="주요 액션 메뉴"
      >
        <div className="mx-auto max-w-[1200px] h-full flex items-stretch">
          <NavBtn icon={I.home} label="홈" active={isHome} onClick={() => navigate("/")} />
          <NavBtn icon={I.reservation} label="예약하기" active={resOpen} onClick={() => setResOpen(true)} />
          <NavBtn icon={I.shop} label="쇼핑몰" active={isShop} onClick={() => navigate("/mall")} />
          <NavBtn icon={I.game} label="게임" active={isGame} onClick={() => navigate("/game")} />
          <NavBtn icon={I.inquiry} label="문의" active={inqOpen} onClick={() => setInqOpen(true)} />
        </div>
      </nav>

      <ReservationChoiceModal open={resOpen} onClose={() => setResOpen(false)} />
      <InquiryModal open={inqOpen} onClose={() => setInqOpen(false)} />
    </>
  );
}
